// extracted by mini-css-extract-plugin
export default {"status":"status___nQA5X","tabPane":"tabPane___whxdB"};